import * as TYPES from '../types';

export const addTeamTypeAction = (payload) => {
    return {
        type: TYPES.ADD_TEAM_TYPE,
        payload: payload
    };
};

export const getAllTeamTypeAction = () => {
    return {
        type: TYPES.GET_ALL_TEAM_TYPE,
    };
};

export const getAllTeamTypeSuccessAction = (payload) => {
    return {
        type: TYPES.GET_ALL_TEAM_TYPE_SUCCESS,
        payload: payload
    };
};

export const deleteTeamTypeAction = (payload) => {
    return {
        type: TYPES.DELETE_TEAM_TYPE,
        payload: payload
    };
};


export const addTeamMemberAction = (payload) => {
    return {
        type: TYPES.ADD_TEAM_MEMBER,
        payload: payload
    };
};

export const getAllTeamMemberAction = () => {
    return {
        type: TYPES.GET_ALL_TEAM_MEMBER,
    };
};

export const getAllTeamMemberSuccessAction = (payload) => {
    return {
        type: TYPES.GET_ALL_TEAM_MEMBER_SUCCESS,
        payload: payload
    };
};

export const deleteTeamMemberAction = (payload) => {
    return {
        type: TYPES.DELETE_TEAM_MEMBER,
        payload: payload
    };
};

export const editTeamMemberAction = (payload) => {
    return {
        type: TYPES.EDIT_TEAM_MEMBER,
        payload: payload
    };
};

export const updateTeamMemberStatusAction = (payload) => {
    return {
        type: TYPES.UPDATE_TEAM_MEMBER_STATUS,
        payload: payload
    };
};
